import type { Announcement } from '~/models';

import { useNuxtApp } from '#app';

const useAnnouncementStore = defineStore('customer-announcement', () => {
  const { $http } = useNuxtApp();

  const list = (): Promise<Announcement[]> => {
    return $http.announcement.list({
      onlyActive: true,
      disabled: false,
      sortBy: 'rank'
    });
  };

  return {
    list
  };
});

export { useAnnouncementStore };
